import { render, staticRenderFns } from "./AccountsPayableSplitTable.vue?vue&type=template&id=5450bfd0&scoped=true&"
import script from "./AccountsPayableSplitTable.vue?vue&type=script&lang=js&"
export * from "./AccountsPayableSplitTable.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5450bfd0",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/builds/echope/echope-front/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5450bfd0')) {
      api.createRecord('5450bfd0', component.options)
    } else {
      api.reload('5450bfd0', component.options)
    }
    module.hot.accept("./AccountsPayableSplitTable.vue?vue&type=template&id=5450bfd0&scoped=true&", function () {
      api.rerender('5450bfd0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/financial/accounts-payable/components/AccountsPayableSplitTable.vue"
export default component.exports